import 'whatwg-fetch';
import merge from 'lodash/merge';

const isResponseError = error => error.status && error.response && error.result;

const createResponseError = (response, result) => {
  const error = new Error(response.statusText);
  error.status = response.status;
  error.response = response;
  error.result = result;
  return error;
};

export const checkResponseStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  return response.json()
    .then((json) => {
      throw createResponseError(response, json);
    })
    .catch((e) => {
      if (isResponseError(e)) {
        throw e;
      } else {
        throw createResponseError(response, e);
      }
    });
};

export const parseJSON = (response) => {
  var contentType = response.headers.get('content-type')
  if (contentType && contentType.indexOf('application/json') !== -1) {
    return response.json();
  } else {
    //if response is not json and mostly empty
    return ({})
  }
}

const defaultFetchOptions = {
  method: 'GET',
  credentials: 'same-origin',
  headers: {
    Accept: 'application/json',
  },
};
export const fetch = (url, options = defaultFetchOptions) =>
  window.fetch(
    url,
    merge({}, defaultFetchOptions, options)
  )
    .then(checkResponseStatus)
    .then(parseJSON);